export default "__VITE_ASSET__BIqRACxU__"